import { Box, Heading, NumberInput, NumberInputField } from '@chakra-ui/react';
import { FC } from 'react';
import { useStore } from '../../../hooks/useStore';
import { shallow } from 'zustand/shallow';
import { AdElementText } from '@adflow/types';

type XPositionInputProps = {
  selectedElement: AdElementText;
};

const XPositionInput: FC<XPositionInputProps> = ({ selectedElement }) => {
  const store = useStore(
    (state) => ({
      selectedElementId: state.selectedElementId,
      updateElementPosition: state.updateElementPosition,
    }),
    shallow,
  );

  const handleXPositionChange = (xPosition: string): void => {
    const xPositionValue: number = parseFloat(xPosition);

    const isValidCoordinate = xPositionValue >= 0;

    store.updateElementPosition(
      selectedElement.id,
      isValidCoordinate ? xPositionValue : 0,
      selectedElement.position.y,
    );
  };

  const handleArrowsForXPosition = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    const { key, target } = event;
    if (key === 'ArrowUp' || key === 'ArrowDown') {
      handleXPositionChange((target as HTMLInputElement).value);
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Heading fontSize="md" fontWeight="semibold">
        X position
      </Heading>
      <NumberInput
        defaultValue={selectedElement.position.x || 0}
        size="sm"
        width={20}
        variant="outline"
        mt={2}
        precision={0}
        min={0}
      >
        <NumberInputField
          data-test-id="x-position-input"
          onChange={(e) => handleXPositionChange(e.target.value)}
          onKeyUp={handleArrowsForXPosition}
        />
      </NumberInput>
    </Box>
  );
};

XPositionInput.displayName = 'XPositionInput';

export default XPositionInput;
